import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import * as customerApis from "../../utilities/apis/customer"

export default function CustomerPreferences({ mobile, className }) {
  const { token } = useSelector(state => state.user)
  const [preferences, setPreferences] = useState(null)

  useEffect(() => {
    let ignore = false
    setPreferences(null)
    if (!mobile) return

    const getPreferences = async () => {
      try {
        const response = await customerApis.getPreferences(token, mobile)
        if (!response.status) throw new Error(response.message)
        if (ignore) return

        setPreferences(response.preferences.map((preference) => ({
          ...preference,
          title: response.options.find((option) => option.product_id === preference.product_id)?.title || `Product ${preference.product_id}`
        })))
      } catch (error) {
        if (!ignore) setPreferences(null)
      }
    }

    getPreferences()
    return () => {
      ignore = true
    }
  }, [mobile])

  if (!preferences) return null

  return (
    <div className={className}>
      <p className="form-label">Preferences</p>
      {preferences.length > 0
        ? (
          <div className="d-flex flex-wrap gap-2">
            {preferences.map((preference) => (
              <span key={`preference-${preference.product_id}`} className="badge rounded-3 p-2 bg-primary-subtle text-primary">{preference.title}: {preference.variant}</span>
            ))}
          </div>
        )
        : <p className="text-body-tertiary m-0">No preferences set</p>}
    </div>
  )
}
